import React from 'react';
import styled, { css } from 'styled-components';

import { Form, Text as TextComponent } from '@components';

const AlternativeAction = styled(props => <TextComponent {...props} />)`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    display: flex;
    width: max-content;
    margin: 0;
    text-align: center;
    gap: ${({ theme }) => theme.spacing(0.5)};

    ${({ hideOnDesktop }) => hideOnDesktop && css`display: none;`}
  }
`;

const AntiphishingData = styled.div`
`;

const AntiphishingField = styled(props => <TextComponent {...props} />)`
  color: ${({ theme }) => theme.palette.grayG};
  font-size: ${({ theme }) => theme.toRem(16)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
  text-transform: capitalize;
`;

const AntiphishingImage = styled.img`
  width: ${({ theme }) => theme.spacing(9)};
  height: ${({ theme }) => theme.spacing(9)};
`;

const AntiphishingWarning = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

const AntiphishingSection = styled.div`
  margin-top: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(1)};
`;

const AntiphishingContent = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1)};
  margin-top: ${({ theme }) => theme.spacing(2)};
`;

const AntiphishingDetails = styled.div`
`;

const FormContainer = styled(props => <Form {...props} />)`
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

const ResponsiveLineBreak = styled.br`
  @media screen and (min-width: ${({ theme }) => theme.breakpoints.small}px) {
    display: none;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.large}px) {
    display: initial;
  }
`;

const Text = styled(props => <TextComponent {...props} />)`
  margin-bottom: 0;
`;

const UnexpectedErrorMessageWrapper = styled.div`
  background: ${({ theme }) => theme.palette.white};
  margin-top: 0;
  margin-bottom: 0;
`;

const NetworkMessageWrapper = styled.span`
  color: ${({ theme }) => theme.palette.danger.main};
  display: block;
  font-family: "RobotoItalic";
`;

const CustomerSupportEmailWrapper = styled.span`
  display: block;
  font-family: "RobotoMedium";
`;

const VPNErrorMessage = styled.p`
  background: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.danger.main};
  font-size: ${({ theme }) => theme.toRem(14)};
  line-height: ${({ theme }) => theme.toRem(20)};
  font-family: ${({ theme }) => theme.typography.font.fontFamily};
  margin: 0;
`;

export {
  AlternativeAction,
  AntiphishingContent,
  AntiphishingData,
  AntiphishingDetails,
  AntiphishingField,
  AntiphishingImage,
  AntiphishingSection,
  AntiphishingWarning,
  CustomerSupportEmailWrapper,
  FormContainer,
  NetworkMessageWrapper,
  ResponsiveLineBreak,
  Text,
  UnexpectedErrorMessageWrapper,
  VPNErrorMessage
};
